module.exports = __webpack_public_path__ + "assets/img/6_489.36b88ec5.jpg";